import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const RepeatScheduleBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RepeatScheduleIntro = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const RepeatScheduleFieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RepeatScheduleField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RepeatScheduleDatePickerWrap = styled.div`
  width: 100%;
`;

export const RepeatScheduleFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
`;
